import { render } from "./GmailCallback.vue?vue&type=template&id=0477c551&scoped=true"
import script from "./GmailCallback.vue?vue&type=script&lang=js"
export * from "./GmailCallback.vue?vue&type=script&lang=js"

import "./GmailCallback.vue?vue&type=style&index=0&id=0477c551&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0477c551"]])

export default __exports__